import { useQueryClient } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';
import { DataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import { restApi } from '../../../services/api';
import useOrderBookStore from '../../../stores/OrderBook/orderBook.store';
import { OrderBookOrder } from '../../../stores/OrderBook/orderBook.types';

const useSalesOpportunityInterceptor = () => {
  const queryClient = useQueryClient();

  const [salesOpportunityInterceptorId, handleChangeSalesOpportunityInterceptor] =
    useOrderBookStore(
      useShallow((state) => [
        state.salesOpportunityInterceptorId,
        state.handleChangeSalesOpportunityInterceptor,
      ]),
    );

  const handleAddInterceptor = (selectedOrder?: OrderBookOrder) => {
    const mustChangeInterceptor = selectedOrder?.customer?.id && !salesOpportunityInterceptorId;
    if (mustChangeInterceptor) {
      const axiosOrderItemInterceptor = restApi.axiosInstance.interceptors.response.use(
        (response) => {
          const { config } = response;
          if (config.url?.includes(`/order-products/order-item-list`) && config.method === 'post') {
            queryClient.removeQueries({ queryKey: [DataQueryKey.ORDER_BOOK_SALES_OPPORTUNITIES] });
          }
          return response;
        },
      );

      handleChangeSalesOpportunityInterceptor(axiosOrderItemInterceptor);
    }
  };

  const handleRemoveInterceptor = (selectedOrder?: OrderBookOrder) => {
    const mustRemoveInterceptor = salesOpportunityInterceptorId && !selectedOrder;
    if (mustRemoveInterceptor) {
      handleChangeSalesOpportunityInterceptor(undefined);
      restApi.axiosInstance.interceptors.response.eject(salesOpportunityInterceptorId);
    }
  };

  return { handleAddInterceptor, handleRemoveInterceptor };
};

export default useSalesOpportunityInterceptor;
